<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="headline pl-4 py-2 pr-2">
        Zablokuj konto <span class="hidden-xs-only">&nbsp;użytkownika</span>
        <v-spacer></v-spacer>
        <v-btn
          @click.native="visibility = false"
          icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4">
        Czy na pewno chcesz zablokować konto użytkownika?
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>

        <v-btn
          color="primary lighten-2"
          flat="flat"
          @click="setVisbility"
        >
          Anuluj
        </v-btn>

        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy"
          @click="lock"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'user-lock-dialog',
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'lock';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    userId() {
      return this.dialogVisibility.id;
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
      'lockUser',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async lock() {
      this.busy = true;
      await this.lockUser(this.userId);
      this.busy = false;
      this.setDialogVisbility(false);
    },
  },
};
</script>
